import React, { Fragment } from 'react'
import LogTable from './LogTable'
import LogViewer from './LogViewer'
import { useStateValue } from '../state'

const LogContainer = () => {
  const [currentState] = useStateValue()

  let child = currentState.selectedLog ? <LogViewer /> : <LogTable />
  return <Fragment>{child}</Fragment>
}
export default LogContainer
